import { useStatesCitiesStore } from '@/store/states_cities';
import { useClientTypeStore } from '@/store/clientTypes';

export const postersOptions = {
    searchStates: async (query: any = '') => {
        const store = useStatesCitiesStore();
        await store.searchStates(query);
        return store.states;
    },
    searchCities: async (query: any = '') => {
        const store = useStatesCitiesStore();
        await store.searchCitiesByState(query);
        return store.cities;
    },
    getClientTypes: async (query: string | Record<string, any> = '') => {
        const store = useClientTypeStore();
        await store.fetchClientTypes(query);
        return store.client_types;
    },
};
